export const environment = {
  appVersion: `${require("../../package.json").version}-test [03/11/2026 11:57]`,
  production: true,
  test: true,
  name: "Test",
  api: "https://test-api.${api-url-variable}/api",
  data: "https://test-api.${api-url-variable}/data",
  dataLoket: "https://test-api.${api-url-variable}/data-loket",
  sts: "https://login.microsoftonline.com/${auth-tenant-id}/v2.0",
  clientId: "",
  lastUpdated: "03/11/2026 11:57",
  // appInsightsInstrumentationKey: "30a4910b-bd3c-414e-84cb-ba34bf536720",
  // InsightsAppName: "Neglect-X-Test",
};